// 表示項目の取得
export const ITEMS_RESET = "common/BreadCrumb/ITEMS_RESET";
export const ITEMS_GET = "common/BreadCrumb/ITEMS_GET";
export const TDB_INFO_SET = "common/BreadCrumb/TDB_INFO_SET";
// リクエストフラグ設定／解除
export const NEEDS_REQUEST_SET = "common/BreadCrumb/NEEDS_REQUEST_SET";
export const NEEDS_REQUEST_UNSET = "common/BreadCrumb/NEEDS_REQUEST_UNSET";
// disc リクエストパラメータセット
export const DISC_PARAMS_SET = "common/BreadCrumb/DISC_PARAMS_SET";
